import { IProductIDs } from '../../shared/models/product.model';

export class ProductRangesConstants {
  public static PRISMA_XS = 50;
  public static MUREVA = 10;
  public static LS_PRODUCT_RANGE_ID = 3;
  public static LN_1_POLE_ID = 14;
  public static LN_3_POLE_ID = 13;
  public static L_3_POLE_ID = 8;

  public static LI_LS_CLARIO_IC_40_RANGE_ID = 43;
  public static LI_LS_ACTI_9_RANGE_ID = 5;
  public static L_4_POLE_ID = 27;

  public static FI_VIGI_CLARIO_IC_40_RANGE_ID = 24;

  public static EINSPEISE_FI_ACTI_9_RANGE_ID = 4;

  public static UTILITY_BREAKER_CLARIO_IC_40_RANGE_ID = 33;

  public static SWITCH_ACTI_9_ISW_RANGE_ID = 37;

  public static SPD_CLARIO_RANGE_ID = 23;

  public static IMPULSE_RELAY_ELECTROMECHANICAL_RANGE_ID = 35;
  public static P_2_POLE_ID = 3;

  public static CONTACTOR_CT_40_RANGE_ID = 48;
  public static CONTACTOR_CT_40_DAY_NIGHT_RANGE_ID = 49;
  public static TIMER_IMPULSE_RELAY_RANGE_ID = 38;

  public static LINEAR_1_SWITCH_RANGE_ID = 25;
  public static LINEAR_2_SWITCHES_RANGE_ID = 55;

  public static NA_POLE_ID = 0;

  public static RCD_TYPE_B_ACTI_9_RANGE_ID = 54;
  public static P_4_POLE_ID = 5;

  public static IMPULSE_RELAY_ELECTRONICAL_RANGE_ID = 42;

  public static CONTACTOR_RANGE_ID = 45;

  public static CONTACTOR_DAY_NIGHT_RANGE_ID = 47;
  public static P_3_POLE_ID = 4;

  public static CONTACTOR_2P_RANGE_ID = 39;
  public static CONTACTOR_1P_RANGE_ID = 46;

  public static P_1_POLE_ID = 1;

  public static VIGI_3P_POLE_ID = 37;
  public static VIGI_4P_POLE_ID = 38;

  public static UNIVERSAL_DIMER_RANGE_ID = 60;
  public static UNIVERSAL_DIMER_SCENE_FUNCTION_RANGE_ID = 61;

  public static PATCHPANEL_16_PORT_RANGE_ID = 76;
  public static PATCHPANEL_8_PORT_RANGE_ID = 77;
  public static PATCHPANEL_4_PORT_RANGE_ID = 78;
  public static TYPE_POWER_STRIP_RANGE_ID = 101;

  public static PRAGMA_MULTI_CUSTOMIZED = 51;
  public static EASY_NET = 52;
  public static TERMINAL_BLOCK_RANGE_ID = 18;
  public static CONTROL_LINE_RANGE_ID = 59;
  public static FEED_IN_BLOCK_CLARIO_3PN = 19;

  public static AFD_RANGE_ID = 93;

  public static AUXILIARY_CONTACT_RANGE_ID = 79;
  public static AUXILIARY_FAULT_CONTACT_RANGE_ID = 80;
  public static NC_AUXILIARY_FAULT_CONTACT_2OC_RANGE_ID = 81;
  public static NC_AUXILIARY_CONTACT_RANGE_ID = 82;
  public static NC_FAULT_CONTACT_RANGE_ID = 83;
  public static NC_AUXILIARY_FAULT_CONTACT_1NO1NC_RANGE_ID = 84;
  // remove NSXM_RANGE_ID, NSX_RANGE_ID, NSX_400_630A_RANGE_ID
  // once SPECIAL_DEVICES_SWITCHBOARD_LABEL_OFFSET from enclosure.constants is moved to BE
  public static NSXM_RANGE_ID = 87;
  public static NSX_RANGE_ID = 88;
  public static NSX_400_630A_RANGE_ID = 91;
  public static GATEWAY_RANGE_ID = 64;
  public static COMPACT_INS_3P_100A_160A_RANGE_ID = 74;
  public static COMPACT_INS_4P_100A_160A_RANGE_ID = 75;
  public static COMPACT_INS_3P_100_250A_RANGE_ID = 85;
  public static COMPACT_INS_4P_100_250A_RANGE_ID = 86;
  public static RCCB_FI_CLARIO_ILD40_RANGE_ID = 102;
  public static CONTRACTORS = [35, 39, 42, 45, 46, 47, 48, 49];
  public static AUTO_GENERATED_LABEL_NAMING = 'AUTOGENERATEDNUMBER';

  public static PATCHPANEL_16_PORT_UNSHIELDED_REFERENCE = '1180-HE116U';
  public static PATCHPANEL_16_PORT_SHIELDED_REFERENCE = '1180-HE116S';
  public static PATCHPANEL_16_PORT_UNSHIELDED_COVER_REFERENCE = '1180-HE100';
  public static PATCHPANEL_16_PORT_SHIELDED_COVER_REFERENCE = '1180-HE110';
  public static PATCHPANEL_8_PORT_REFERENCE = '1180-HE216U';
  public static PATCHPANEL_8_PORT_COVER_REFERENCE = '1180-HE200';
  public static PATCHPANEL_4_PORT_REFERENCE = '1180-HE204U';
  public static EASY_NET_RJ45_UNSHIELDED_REFERENCE = '1180-118.U.REG';
  public static EASY_NET_RJ45_SHIELDED_REFERENCE = '1180-118.S.REG';
  public static EASY_NET_PROTECTION = '1180-000.REG';
  public static STECKDOSE = '87003.FLF.SET.B.61';
  public static STECKDOSE_EINLASSKATEN = '87003.FLF.SET.61';
  public static INSTALLATION_KIT_1_METER = 'SZMT1381M';

  public static REFERENCES_WITH_SPECIAL_FIELD_PLACEMENT = ['PME425D0', 'PME426D0'];

  public static DEVICES_PLACEABLE_ON_COMB_BASED_AUXILIARY: IProductIDs[] = [
    { productRangeId: ProductRangesConstants.LS_PRODUCT_RANGE_ID, productPoleId: ProductRangesConstants.LN_1_POLE_ID },
    { productRangeId: ProductRangesConstants.LS_PRODUCT_RANGE_ID, productPoleId: ProductRangesConstants.LN_3_POLE_ID },
    { productRangeId: ProductRangesConstants.LS_PRODUCT_RANGE_ID, productPoleId: ProductRangesConstants.L_3_POLE_ID },
    { productRangeId: ProductRangesConstants.LI_LS_CLARIO_IC_40_RANGE_ID, productPoleId: ProductRangesConstants.LN_1_POLE_ID },
    { productRangeId: ProductRangesConstants.LI_LS_CLARIO_IC_40_RANGE_ID, productPoleId: ProductRangesConstants.LN_3_POLE_ID },
    { productRangeId: ProductRangesConstants.EINSPEISE_FI_ACTI_9_RANGE_ID, productPoleId: ProductRangesConstants.L_4_POLE_ID },
    { productRangeId: ProductRangesConstants.RCD_TYPE_B_ACTI_9_RANGE_ID, productPoleId: ProductRangesConstants.P_4_POLE_ID },
    { productRangeId: ProductRangesConstants.RCD_TYPE_B_ACTI_9_RANGE_ID, productPoleId: ProductRangesConstants.P_2_POLE_ID },
    { productRangeId: ProductRangesConstants.SWITCH_ACTI_9_ISW_RANGE_ID, productPoleId: ProductRangesConstants.L_4_POLE_ID},
    { productRangeId: ProductRangesConstants.LS_PRODUCT_RANGE_ID, productPoleId: ProductRangesConstants.P_2_POLE_ID },
    { productRangeId: ProductRangesConstants.LS_PRODUCT_RANGE_ID, productPoleId: ProductRangesConstants.L_4_POLE_ID }
  ]
  public static SKIP_FROM_SLD = [ProductRangesConstants.FI_VIGI_CLARIO_IC_40_RANGE_ID];

  public static NUMBER_OF_COMB_BUS_BAR_CUTTING_SLOTS = {
    ACTI9_IC60_3PN: 8,
    ACTI9_IC60_1PN: 4,
  }

  public static LEAKAGE_CURRENT_30 = {
    value: 30,
    label: 'A, 30mA'
  }
}
